import { showCountDetailsModal } from "@actions/modals";
import collections from "@api/collections";
import count from "@api/count";
import { handleDownload } from "@helpers/downloads";
import DataGrid from "@shared/DataGrid";
import DetailsButton from "@shared/DetailsButton";
import React from "react";
import { connect } from "react-redux";
import { Button, Dropdown, Grid, Icon } from "semantic-ui-react";
import CollectionFilters from "./CollectionFilters";

class MachineCounts extends React.Component {
  state = {
    loading: false,
    currentWeek: true,
    exportLoading: false,
    reportLoading: false,
    row: null,
    from: null,
    to: null,
    periods: [],
    grid: {
      data: [],
      headerDef: [],
      rowDef: [],
    },
    activeRow: {
      optionShowDetails: false,
      batchId: null,
    },
  };

  onRowClick = (activeRow) => this.setState({ activeRow });

  handleRefresh = () => {
    const { from, currentWeek, periods } = this.state;
    if (periods.length) {
      this.setState({ loading: true }, () => {
        const { siteId, operator } = this.props;
        const to = currentWeek ? "-1" : this.state.to;
        count.getCounts(operator, siteId, from, to).then(
          (grid) => this.setState({ loading: false, grid }),
          () => this.setState({ loading: false }),
        );
      });
    }
  };

  componentDidMount() {
    this.loadPeriods();
  }

  loadPeriods = () => {
    const { siteId, operator } = this.props;
    this.setState(
      {
        loading: true,
        grid: {
          data: [],
          headerDef: [],
          rowDef: [],
        },
        periods: [],
      },
      () => {
        this.setState({ loading: false }, () => {
          if (siteId) {
            this.setState({ loading: true }, () => {
              collections.getPeriods(operator, siteId).then(
                (periods) => {
                  const defaultPeriod =
                    periods.find((period) => period.isDefault) || periods[0];
                  this.setState(
                    {
                      periods,
                      from: defaultPeriod ? defaultPeriod.value : null,
                      loading: false,
                    },
                    () => {
                      if (periods.length > 0) this.handleRefresh();
                    },
                  );
                },
                () => this.setState({ loading: false }),
              );
            });
          }
        });
      },
    );
  };

  componentDidUpdate(prevProps) {
    if (
      this.props.siteId !== prevProps.siteId ||
      this.props.operator !== prevProps.operator
    ) {
      this.loadPeriods();
    }
  }

  setCurrentWeek = () =>
    this.setState({ currentWeek: !this.state.currentWeek });

  onChange = (event, { name, value }) => this.setState({ [name]: value });

  onDetailsClick = async () => {
    const { batchId, collectionType } = this.state.activeRow;
    this.props.showCountDetailsModal(
      { batchId, collectionType },
      this.handleRefresh,
    );
  };

  downloadReport = () => {
    const { batchId, collectionType } = this.state.activeRow;
    this.setState({ reportLoading: true }, () => {
      count.getReportPdf(batchId, collectionType).then(
        (response) =>
          this.setState({ reportLoading: false }, () =>
            handleDownload(response),
          ),
        () => this.setState({ reportLoading: false }),
      );
    });
  };

  onExportClick = () => {
    const { from, currentWeek, periods } = this.state;
    if (periods.length) {
      this.setState({ exportLoading: true }, () => {
        const { siteId, operator } = this.props;
        const to = currentWeek ? "-1" : this.state.to;
        count.getCountsExport(operator, siteId, from, to).then(
          (response) =>
            this.setState({ exportLoading: false }, () =>
              handleDownload(response),
            ),
          () => this.setState({ exportLoading: false }),
        );
      });
    }
  };

  render() {
    const { headerDef, rowDef, data } = this.state.grid;
    const { activeRow, reportLoading, loading, exportLoading } = this.state;
    return (
      <Grid className="height-100 gs-flex-container-vertical">
        <Grid.Row>
          <Grid.Column width="10">
            <CollectionFilters
              {...this.state}
              onChange={this.onChange}
              onChangeCurrentWeek={this.setCurrentWeek}
              onVarianceClick={() => {}}
              onExportClick={this.onExportClick}
              onRefreshClick={this.handleRefresh}
              loadingExport={exportLoading}
              showVarianceHistory={false}
            />
          </Grid.Column>
          <Grid.Column textAlign="right" width="6">
            <Dropdown
              direction="left"
              icon={null}
              trigger={
                <Button
                  disabled={!activeRow.batchId || loading}
                  color="teal"
                  loading={reportLoading}
                  icon
                  labelPosition="right"
                >
                  <Icon name="caret down" /> Reports
                </Button>
              }
            >
              <Dropdown.Menu>
                <Dropdown.Item
                  text="Machine Count"
                  onClick={this.downloadReport}
                />
              </Dropdown.Menu>
            </Dropdown>
            <DetailsButton
              disabled={!activeRow.batchId || loading}
              onClick={this.onDetailsClick}
            />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row className="flex-stretch">
          <Grid.Column width="16" className="gs-flex-container-vertical">
            <DataGrid
              loading={loading}
              headings={headerDef}
              data={data}
              activeRow={this.state.activeRow}
              rowDef={rowDef}
              onRowClick={this.onRowClick}
              fullHeight
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
}

export default connect(null, { showCountDetailsModal })(MachineCounts);
